import { CustomLanguage } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../shared/components/Text';

export const CustomLanguageOptions = Object.values(CustomLanguage).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
